import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import colors from '../../../../scss/colors';
import classes from './OutlinedCheckBox.module.scss';

const OutlinedCheckBox = ({ value, onChange, disabled = false, size = '16px' }) => {
  return (
    <label className={classes.container}>
      <input
        data-testid="outlinedcheckbox"
        disabled={disabled}
        type="checkbox"
        checked={value}
        onChange={() => {
          if (!disabled) onChange();
        }}
      />
      <div className={`${classes.wrapper} ${disabled ? classes.disabled : ''}`} style={{ width: size, height: size }}>
        {value ? <CheckIcon sx={{ fontSize: size, color: colors.PRIMARY_BLUE }} /> : ''}
      </div>
    </label>
  );
};

export default OutlinedCheckBox;
